/* Paket kartları: seçilen varyanta göre gizli id, fiyat, buton ve yapışkan sepet çubuğunu günceller. */
(function () {
  function setText(el, text) {
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  function update(input) {
    var box = input.closest('[data-buy-box]');
    if (!box) return;

    var idInput = box.querySelector('input[name="id"]');
    if (idInput) idInput.value = input.value;

    var price = box.querySelector('[data-price]');
    if (price) price.textContent = input.getAttribute('data-price');
    setText(box.querySelector('[data-compare]'), input.getAttribute('data-compare'));
    setText(box.querySelector('[data-save]'), input.getAttribute('data-save'));

    var available = input.getAttribute('data-available') === 'true';
    var button = box.querySelector('[data-add]');
    var label = box.querySelector('[data-add-label]');
    if (button) button.disabled = !available;
    if (label) label.textContent = label.getAttribute(available ? 'data-label-add' : 'data-label-sold');

    box.querySelectorAll('.bundle').forEach(function (card) {
      card.classList.toggle('is-selected', card.contains(input));
    });

    if (box.getAttribute('data-update-url') === 'true' && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url.toString());
    }

    document.dispatchEvent(new CustomEvent('medicore:variant', {
      detail: {
        box: box,
        id: input.value,
        title: input.getAttribute('data-title'),
        price: input.getAttribute('data-price'),
        compare: input.getAttribute('data-compare'),
        available: available
      }
    }));
  }

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (t && t.matches && t.matches('input[data-bundle-input]')) update(t);
  });

  /* Yapışkan sepet çubuğu */
  function initSticky() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var box = document.querySelector('[data-buy-box][data-main]');
    if (!box) return;
    var form = box.querySelector('form[data-product-form]');
    var mainButton = box.querySelector('[data-add]');

    document.addEventListener('medicore:variant', function (e) {
      if (e.detail.box !== box) return;
      var d = e.detail;
      var t = bar.querySelector('[data-sticky-title]');
      var p = bar.querySelector('[data-sticky-price]');
      var b = bar.querySelector('[data-sticky-add]');
      if (t) t.textContent = d.title || '';
      if (p) p.textContent = d.price || '';
      setText(bar.querySelector('[data-sticky-compare]'), d.compare);
      if (b) b.disabled = !d.available;
    });

    bar.querySelector('[data-sticky-add]').addEventListener('click', function () {
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });

    if ('IntersectionObserver' in window && mainButton) {
      new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', hidden);
        document.body.classList.toggle('has-sticky-atc', hidden);
      }).observe(mainButton);
    } else {
      bar.classList.add('is-visible');
      document.body.classList.add('has-sticky-atc');
    }
  }

  
  /* Mobil Üç Çizgi Menü: Açıldığında altındaki Hero metninin üstüne binmemesi için yüksekliği kadar boşluk bırakır */
  function initMobileMenu() {
    var menuToggle = document.querySelector('.menu-toggle');
    var header = document.querySelector('.header');
    var panel = document.querySelector('.menu-toggle__panel');
    if (!menuToggle || !header || !panel) return;

    function syncMenuSpace() {
      if (menuToggle.open && window.innerWidth <= 749) {
        header.style.marginBottom = panel.offsetHeight + 'px';
      } else {
        header.style.marginBottom = '0px';
      }
    }

    menuToggle.addEventListener('toggle', syncMenuSpace);
    window.addEventListener('resize', syncMenuSpace);

    document.addEventListener('click', function (e) {
      if (menuToggle.open && !menuToggle.contains(e.target)) {
        menuToggle.removeAttribute('open');
        syncMenuSpace();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSticky();
    initMobileMenu();
    document.querySelectorAll('input[data-bundle-input]:checked').forEach(update);
  });
})();
